import axios from 'axios';

const API = '/api/tenant/item-type';
const ADMIN_API = '/api/tenant/item-type-admin';

export default {
  // Kaikki tyypit järjestyksessä, myös käytöstä poistetut; käytä store/helpers/itemTypes.js:n välimuistia.
  async getItemTypes() {
    return await axios({ url: API }).then(r => r.data);
  },
  // Teknisen ylläpidon hallinta: tyypit nimikkeiden määrineen.
  async getItemTypesAdmin() {
    return await axios({ url: ADMIN_API }).then(r => r.data);
  },
  async createItemType(data) {
    return await axios({ url: ADMIN_API, method: 'post', data }).then(r => r.data);
  },
  async updateItemType(id, data) {
    return await axios({ url: `${ADMIN_API}/${id}`, method: 'put', data }).then(r => r.data);
  },
  async reorderItemTypes(orderedIds) {
    return await axios({ url: `${ADMIN_API}/order`, method: 'put', data: orderedIds }).then(r => r.data);
  },
  async removeItemType(id) {
    return await axios({ url: `${ADMIN_API}/${id}`, method: 'delete' }).then(r => r.data);
  },
};
